import "./SociallyResponsibleCompany.module.css";
import Header from "@/reusable_sections/Header";
import IntroducciN from "./sections/IntroducciN";
import ReasDeImpacto from "./sections/ReasDeImpacto";
import GalerADeIniciativas from "./sections/GalerADeIniciativas";
import Footer from "@/reusable_sections/Footer";
import Photogrid from "./sections/Photogrid";
export default function SociallyResponsibleCompanyPage() {
  return <div>
      <Header />
      <IntroducciN />
      <Photogrid />
      <ReasDeImpacto />
      <GalerADeIniciativas />
      <Footer />
    </div>;
}